
import React from 'react';

interface AppLayoutProps {
  children: React.ReactNode;
  className?: string;
  // Legacy props for backward compatibility - now ignored
  showNavigation?: boolean;
  transparentNav?: boolean;
  hideNavigation?: boolean;
  showHeader?: boolean;
  showBottomNav?: boolean;
  globalPageTitle?: string;
  showGlobalHeader?: boolean;
  headerTitle?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
  rightContent?: React.ReactNode;
  pageHeaderProps?: any;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  children,
  className,
  // All legacy props are now ignored to prevent conflicts
}) => {
  return (
    <div className={`min-h-screen bg-gradient-to-br from-slate-950 via-purple-950/20 to-slate-950 ${className || ''}`}>
      <main className="relative">
        {children}
      </main>
    </div>
  );
};
